export class RecurrenceRule {
  public name: string = "";
  public cron: string = "0 0 0 1 */1 ?";
  public fabricExportableClassName: string = "";
  public script: string = "";
  public id?: string = "";
  public $decodedScript: any = {};
}

export class Destinataire {
  public name: string = "";
  public fabricClassName: string = "FabricDestinationEmail";
  public script: string = "";
  public id?: string = "";
  public active: boolean = true;
  public $decodedScript: any = {};
  public $typeDest: string = "FTP";
  public $abonnements?: any[] = new Array();
}

export class Abonnement {
  public id: string = "";
  public regleDestinations: Destinataire[] = new Array();
  public regleExportable: RecurrenceRule = new RecurrenceRule();
}

export class RecurenceConfig {
  public nomChamp: string = "";
  public typeChamp: string = "";
  public valeurPossible?: string[] = new Array();
}
